import { Router } from '@angular/router';
import OAuth2AuthProvider from '../lib/services/auth-providers/oauth2.provider';
import { SessionClaims, SessionsServiceConfig, SessionsServiceConfigProvider } from '../lib/services/sessions.service';
import { Injectable } from '@angular/core';
import { CustomAuthProvider as CustomTokenProvider } from '../lib/services/auth-providers/custom.provider';
import {
  UsernamePasswordOAuth2GrantType,
  AuthorizationCodeOAuth2GrantType,
  ClientCredentialsOAuth2GrantType,
} from '../lib/services/auth-providers/oauth2-grant-types';
import { SessionSignInFlag } from '../lib/components/session-signin/session-signin.component';

@Injectable()
export class DefaultSessionsServiceConfigProvider implements SessionsServiceConfigProvider {
  public constructor(private router: Router) {}

  public getConfig(): SessionsServiceConfig {
    return {
      autoRefreshCredentials: true,
      persistSessions: true,
      onSelectionRequired: () => {
        // Do nothing, don't navigate to session/select
      },
      onSignInRequired: (session) => {
        const currentUrl = this.router.url;
        if (currentUrl !== '/app/fleet-management') {
          this.router.navigate(['session', 'signin'], {
            queryParams: { prefill_session: session.id, flags: SessionSignInFlag.SignInRequired },
          });
        }
      },
      onSessionActivated: () => this.router.navigate(['']),
      sessionDiscriminator: (session) => session.id,
      authProviders: [
        new OAuth2AuthProvider('oauth2_username_password', {
          label: 'OAuth2 - Username + Password',
          icon: 'pi pi-key',
          clientId: 'oauth2-username-password',
          clientSecret: '15GJ7qipHHnHA7KQrgno3HM42nznfmcR',
          grantType: new UsernamePasswordOAuth2GrantType(),
          redirectUrl: 'http://localhost:4200/session/oauth2/callback',
          scopes: ['basic'],
          tokenUrl: 'http://localhost:8080/realms/master/protocol/openid-connect/token',
          extractClaimsFromToken: async (_access_token, _): Promise<SessionClaims> => {
            return {
              id: _access_token['sub'] ?? '',
              username: (_access_token['azp'] as string) ?? '',
            };
          },
          extractSessionIdFromToken: async (_access_token, _) => _access_token.sub!,
        }),
        new OAuth2AuthProvider('oauth2_authorization_code', {
          label: 'OAuth2 - Authorization Code',
          icon: 'pi pi-google',
          clientId: '',
          grantType: new AuthorizationCodeOAuth2GrantType(),
          redirectUrl: 'http://localhost:4200/session/oauth2/callback',
          scopes: ['email', 'openid', 'phone'],
          authorizationUrl: '',
          tokenUrl: '',
          extractClaimsFromToken: async (_, id_token) => {
            return {
              id: id_token!.sub,
              username: id_token!['email'],
            } as SessionClaims;
          },
          extractSessionIdFromToken: async (_, id_token) => id_token!.sub!,
        }),
        new CustomTokenProvider('custom_token', {
          label: 'Custom Token',
          icon: 'pi pi-cog',
          authenticate: async (credentials) => {
            return {
              accessToken: 'token',
              refreshToken: 'refreshToken',
              expiresAt: new Date().getTime() + 30 * 1000,
              claims: {
                id: credentials['email'],
                username: credentials['email'],
                imageUri:
                  'https://s2.qwant.com/thumbr/474x690/f/2/8f10edb008155400d5b4482fa744a5b15990aadd16e0b654da0b859016e424/th.jpg?u=https%3A%2F%2Ftse.mm.bing.net%2Fth%3Fid%3DOIP.jPGxI1SPqFhWgd4c_ACEEQHaKy%26r%3D0%26pid%3DApi&q=0&b=1&p=0&a=0',
              },
            };
          },
          fields: [
            {
              key: 'email',
              type: 'email',
              icon: 'pi pi-at',
              label: 'Email',
              saveForPrefill: true,
            },
          ],
          getSessionIdentifier: (token, claims) => claims.id,
        }),
      ],
    } as SessionsServiceConfig;
  }
}
